export const DIVIPOLA_DEPARTMENTS = [
    { code: '05', name: "Antioquia" },
    { code: '08', name: "Atlántico" },
    { code: '11', name: "Bogotá, D.C." },
    { code: '13', name: "Bolívar" },
    { code: '15', name: "Boyacá" },
    { code: '17', name: "Caldas" },
    { code: '18', name: "Caquetá" },
    { code: '19', name: "Cauca" },
    { code: '20', name: "Cesar" },
    { code: '23', name: "Córdoba" },
    { code: '25', name: "Cundinamarca" },
    { code: '27', name: "Chocó" },
    { code: '41', name: "Huila" },
    { code: '44', name: "La Guajira" },
    { code: '47', name: "Magdalena" },
    { code: '50', name: "Meta" },
    { code: '52', name: "Nariño" },
    { code: '54', name: "Norte de Santander" },
    { code: '63', name: "Quindío" },
    { code: '66', name: "Risaralda" },
    { code: '68', name: "Santander" },
    { code: '70', name: "Sucre" },
    { code: '73', name: "Tolima" },
    { code: '76', name: "Valle del Cauca" },
    { code: '81', name: "Arauca" },
    { code: '85', name: "Casanare" },
    { code: '86', name: "Putumayo" },
    { code: '88', name: "Archipiélago de San Andrés, Providencia y Santa Catalina" },
    { code: '91', name: "Amazonas" },
    { code: '94', name: "Guainía" },
    { code: '95', name: "Guaviare" },
    { code: '97', name: "Vaupés" },
    { code: '99', name: "Vichada" },
];
/** Municipios en orden de código; el departamento son los dos primeros dígitos. */
export const DIVIPOLA_MUNICIPALITIES = [
    { code: '05001', name: "Medellín" },
    { code: '05002', name: "Abejorral" },
    { code: '05004', name: "Abriaquí" },
    { code: '05021', name: "Alejandría" },
    { code: '05030', name: "Amagá" },
    { code: '05031', name: "Amalfi" },
    { code: '05034', name: "Andes" },
    { code: '05036', name: "Angelópolis" },
    { code: '05038', name: "Angostura" },
    { code: '05040', name: "Anorí" },
    { code: '05042', name: "Santa Fé de Antioquia" },
    { code: '05044', name: "Anzá" },
    { code: '05045', name: "Apartadó" },
    { code: '05051', name: "Arboletes" },
    { code: '05055', name: "Argelia" },
    { code: '05059', name: "Armenia" },
    { code: '05079', name: "Barbosa" },
    { code: '05086', name: "Belmira" },
    { code: '05088', name: "Bello" },
    { code: '05091', name: "Betania" },
    { code: '05093', name: "Betulia" },
    { code: '05101', name: "Ciudad Bolívar" },
    { code: '05107', name: "Briceño" },
    { code: '05113', name: "Buriticá" },
    { code: '05120', name: "Cáceres" },
    { code: '05125', name: "Caicedo" },
    { code: '05129', name: "Caldas" },
    { code: '05134', name: "Campamento" },
    { code: '05138', name: "Cañasgordas" },
    { code: '05142', name: "Caracolí" },
    { code: '05145', name: "Caramanta" },
    { code: '05147', name: "Carepa" },
    { code: '05148', name: "El Carmen de Viboral" },
    { code: '05150', name: "Carolina" },
    { code: '05154', name: "Caucasia" },
    { code: '05172', name: "Chigorodó" },
    { code: '05190', name: "Cisneros" },
    { code: '05197', name: "Cocorná" },
    { code: '05206', name: "Concepción" },
    { code: '05209', name: "Concordia" },
    { code: '05212', name: "Copacabana" },
    { code: '05234', name: "Dabeiba" },
    { code: '05237', name: "Donmatías" },
    { code: '05240', name: "Ebéjico" },
    { code: '05250', name: "El Bagre" },
    { code: '05264', name: "Entrerríos" },
    { code: '05266', name: "Envigado" },
    { code: '05282', name: "Fredonia" },
    { code: '05284', name: "Frontino" },
    { code: '05306', name: "Giraldo" },
    { code: '05308', name: "Girardota" },
    { code: '05310', name: "Gómez Plata" },
    { code: '05313', name: "Granada" },
    { code: '05315', name: "Guadalupe" },
    { code: '05318', name: "Guarne" },
    { code: '05321', name: "Guatapé" },
    { code: '05347', name: "Heliconia" },
    { code: '05353', name: "Hispania" },
    { code: '05360', name: "Itagüí" },
    { code: '05361', name: "Ituango" },
    { code: '05364', name: "Jardín" },
    { code: '05368', name: "Jericó" },
    { code: '05376', name: "La Ceja" },
    { code: '05380', name: "La Estrella" },
    { code: '05390', name: "La Pintada" },
    { code: '05400', name: "La Unión" },
    { code: '05411', name: "Liborina" },
    { code: '05425', name: "Maceo" },
    { code: '05440', name: "Marinilla" },
    { code: '05467', name: "Montebello" },
    { code: '05475', name: "Murindó" },
    { code: '05480', name: "Mutatá" },
    { code: '05483', name: "Nariño" },
    { code: '05490', name: "Necoclí" },
    { code: '05495', name: "Nechí" },
    { code: '05501', name: "Olaya" },
    { code: '05541', name: "Peñol" },
    { code: '05543', name: "Peque" },
    { code: '05576', name: "Pueblorrico" },
    { code: '05579', name: "Puerto Berrío" },
    { code: '05585', name: "Puerto Nare" },
    { code: '05591', name: "Puerto Triunfo" },
    { code: '05604', name: "Remedios" },
    { code: '05607', name: "Retiro" },
    { code: '05615', name: "Rionegro" },
    { code: '05628', name: "Sabanalarga" },
    { code: '05631', name: "Sabaneta" },
    { code: '05642', name: "Salgar" },
    { code: '05647', name: "San Andrés de Cuerquía" },
    { code: '05649', name: "San Carlos" },
    { code: '05652', name: "San Francisco" },
    { code: '05656', name: "San Jerónimo" },
    { code: '05658', name: "San José de la Montaña" },
    { code: '05659', name: "San Juan de Urabá" },
    { code: '05660', name: "San Luis" },
    { code: '05664', name: "San Pedro de los Milagros" },
    { code: '05665', name: "San Pedro de Urabá" },
    { code: '05667', name: "San Rafael" },
    { code: '05670', name: "San Roque" },
    { code: '05674', name: "San Vicente Ferrer" },
    { code: '05679', name: "Santa Bárbara" },
    { code: '05686', name: "Santa Rosa de Osos" },
    { code: '05690', name: "Santo Domingo" },
    { code: '05697', name: "El Santuario" },
    { code: '05736', name: "Segovia" },
    { code: '05756', name: "Sonsón" },
    { code: '05761', name: "Sopetrán" },
    { code: '05789', name: "Támesis" },
    { code: '05790', name: "Tarazá" },
    { code: '05792', name: "Tarso" },
    { code: '05809', name: "Titiribí" },
    { code: '05819', name: "Toledo" },
    { code: '05837', name: "Turbo" },
    { code: '05842', name: "Uramita" },
    { code: '05847', name: "Urrao" },
    { code: '05854', name: "Valdivia" },
    { code: '05856', name: "Valparaíso" },
    { code: '05858', name: "Vegachí" },
    { code: '05861', name: "Venecia" },
    { code: '05873', name: "Vigía del Fuerte" },
    { code: '05885', name: "Yalí" },
    { code: '05887', name: "Yarumal" },
    { code: '05890', name: "Yolombó" },
    { code: '05893', name: "Yondó" },
    { code: '05895', name: "Zaragoza" },
    { code: '08001', name: "Barranquilla" },
    { code: '08078', name: "Baranoa" },
    { code: '08137', name: "Campo de la Cruz" },
    { code: '08141', name: "Candelaria" },
    { code: '08296', name: "Galapa" },
    { code: '08372', name: "Juan de Acosta" },
    { code: '08421', name: "Luruaco" },
    { code: '08433', name: "Malambo" },
    { code: '08436', name: "Manatí" },
    { code: '08520', name: "Palmar de Varela" },
    { code: '08549', name: "Piojó" },
    { code: '08558', name: "Polonuevo" },
    { code: '08560', name: "Ponedera" },
    { code: '08573', name: "Puerto Colombia" },
    { code: '08606', name: "Repelón" },
    { code: '08634', name: "Sabanagrande" },
    { code: '08638', name: "Sabanalarga" },
    { code: '08675', name: "Santa Lucía" },
    { code: '08685', name: "Santo Tomás" },
    { code: '08758', name: "Soledad" },
    { code: '08770', name: "Suan" },
    { code: '08832', name: "Tubará" },
    { code: '08849', name: "Usiacurí" },
    { code: '11001', name: "Bogotá, D.C." },
    { code: '13001', name: "Cartagena de Indias" },
    { code: '13006', name: "Achí" },
    { code: '13030', name: "Altos del Rosario" },
    { code: '13042', name: "Arenal" },
    { code: '13052', name: "Arjona" },
    { code: '13062', name: "Arroyohondo" },
    { code: '13074', name: "Barranco de Loba" },
    { code: '13140', name: "Calamar" },
    { code: '13160', name: "Cantagallo" },
    { code: '13188', name: "Cicuco" },
    { code: '13212', name: "Córdoba" },
    { code: '13222', name: "Clemencia" },
    { code: '13244', name: "El Carmen de Bolívar" },
    { code: '13248', name: "El Guamo" },
    { code: '13268', name: "El Peñón" },
    { code: '13300', name: "Hatillo de Loba" },
    { code: '13430', name: "Magangué" },
    { code: '13433', name: "Mahates" },
    { code: '13440', name: "Margarita" },
    { code: '13442', name: "María la Baja" },
    { code: '13458', name: "Montecristo" },
    { code: '13468', name: "Santa Cruz de Mompox" },
    { code: '13473', name: "Morales" },
    { code: '13490', name: "Norosí" },
    { code: '13549', name: "Pinillos" },
    { code: '13580', name: "Regidor" },
    { code: '13600', name: "Río Viejo" },
    { code: '13620', name: "San Cristóbal" },
    { code: '13647', name: "San Estanislao" },
    { code: '13650', name: "San Fernando" },
    { code: '13654', name: "San Jacinto" },
    { code: '13655', name: "San Jacinto del Cauca" },
    { code: '13657', name: "San Juan Nepomuceno" },
    { code: '13667', name: "San Martín de Loba" },
    { code: '13670', name: "San Pablo" },
    { code: '13673', name: "Santa Catalina" },
    { code: '13683', name: "Santa Rosa" },
    { code: '13688', name: "Santa Rosa del Sur" },
    { code: '13744', name: "Simití" },
    { code: '13760', name: "Soplaviento" },
    { code: '13780', name: "Talaigua Nuevo" },
    { code: '13810', name: "Tiquisio" },
    { code: '13836', name: "Turbaco" },
    { code: '13838', name: "Turbaná" },
    { code: '13873', name: "Villanueva" },
    { code: '13894', name: "Zambrano" },
    { code: '15001', name: "Tunja" },
    { code: '15022', name: "Almeida" },
    { code: '15047', name: "Aquitania" },
    { code: '15051', name: "Arcabuco" },
    { code: '15087', name: "Belén" },
    { code: '15090', name: "Berbeo" },
    { code: '15092', name: "Betéitiva" },
    { code: '15097', name: "Boavita" },
    { code: '15104', name: "Boyacá" },
    { code: '15106', name: "Briceño" },
    { code: '15109', name: "Buenavista" },
    { code: '15114', name: "Busbanzá" },
    { code: '15131', name: "Caldas" },
    { code: '15135', name: "Campohermoso" },
    { code: '15162', name: "Cerinza" },
    { code: '15172', name: "Chinavita" },
    { code: '15176', name: "Chiquinquirá" },
    { code: '15180', name: "Chiscas" },
    { code: '15183', name: "Chita" },
    { code: '15185', name: "Chitaraque" },
    { code: '15187', name: "Chivatá" },
    { code: '15189', name: "Ciénega" },
    { code: '15204', name: "Cómbita" },
    { code: '15212', name: "Coper" },
    { code: '15215', name: "Corrales" },
    { code: '15218', name: "Covarachía" },
    { code: '15223', name: "Cubará" },
    { code: '15224', name: "Cucaita" },
    { code: '15226', name: "Cuítiva" },
    { code: '15232', name: "Chíquiza" },
    { code: '15236', name: "Chivor" },
    { code: '15238', name: "Duitama" },
    { code: '15244', name: "El Cocuy" },
    { code: '15248', name: "El Espino" },
    { code: '15272', name: "Firavitoba" },
    { code: '15276', name: "Floresta" },
    { code: '15293', name: "Gachantivá" },
    { code: '15296', name: "Gámeza" },
    { code: '15299', name: "Garagoa" },
    { code: '15317', name: "Guacamayas" },
    { code: '15322', name: "Guateque" },
    { code: '15325', name: "Guayatá" },
    { code: '15332', name: "Güicán de la Sierra" },
    { code: '15362', name: "Iza" },
    { code: '15367', name: "Jenesano" },
    { code: '15368', name: "Jericó" },
    { code: '15377', name: "Labranzagrande" },
    { code: '15380', name: "La Capilla" },
    { code: '15401', name: "La Victoria" },
    { code: '15403', name: "La Uvita" },
    { code: '15407', name: "Villa de Leyva" },
    { code: '15425', name: "Macanal" },
    { code: '15442', name: "Maripí" },
    { code: '15455', name: "Miraflores" },
    { code: '15464', name: "Mongua" },
    { code: '15466', name: "Monguí" },
    { code: '15469', name: "Moniquirá" },
    { code: '15476', name: "Motavita" },
    { code: '15480', name: "Muzo" },
    { code: '15491', name: "Nobsa" },
    { code: '15494', name: "Nuevo Colón" },
    { code: '15500', name: "Oicatá" },
    { code: '15507', name: "Otanche" },
    { code: '15511', name: "Pachavita" },
    { code: '15514', name: "Páez" },
    { code: '15516', name: "Paipa" },
    { code: '15518', name: "Pajarito" },
    { code: '15522', name: "Panqueba" },
    { code: '15531', name: "Pauna" },
    { code: '15533', name: "Paya" },
    { code: '15537', name: "Paz de Río" },
    { code: '15542', name: "Pesca" },
    { code: '15550', name: "Pisba" },
    { code: '15572', name: "Puerto Boyacá" },
    { code: '15580', name: "Quípama" },
    { code: '15599', name: "Ramiriquí" },
    { code: '15600', name: "Ráquira" },
    { code: '15621', name: "Rondón" },
    { code: '15632', name: "Saboyá" },
    { code: '15638', name: "Sáchica" },
    { code: '15646', name: "Samacá" },
    { code: '15660', name: "San Eduardo" },
    { code: '15664', name: "San José de Pare" },
    { code: '15667', name: "San Luis de Gaceno" },
    { code: '15673', name: "San Mateo" },
    { code: '15676', name: "San Miguel de Sema" },
    { code: '15681', name: "San Pablo de Borbur" },
    { code: '15686', name: "Santana" },
    { code: '15690', name: "Santa María" },
    { code: '15693', name: "Santa Rosa de Viterbo" },
    { code: '15696', name: "Santa Sofía" },
    { code: '15720', name: "Sativanorte" },
    { code: '15723', name: "Sativasur" },
    { code: '15740', name: "Siachoque" },
    { code: '15753', name: "Soatá" },
    { code: '15755', name: "Socotá" },
    { code: '15757', name: "Socha" },
    { code: '15759', name: "Sogamoso" },
    { code: '15761', name: "Somondoco" },
    { code: '15762', name: "Sora" },
    { code: '15763', name: "Sotaquirá" },
    { code: '15764', name: "Soracá" },
    { code: '15774', name: "Susacón" },
    { code: '15776', name: "Sutamarchán" },
    { code: '15778', name: "Sutatenza" },
    { code: '15790', name: "Tasco" },
    { code: '15798', name: "Tenza" },
    { code: '15804', name: "Tibaná" },
    { code: '15806', name: "Tibasosa" },
    { code: '15808', name: "Tinjacá" },
    { code: '15810', name: "Tipacoque" },
    { code: '15814', name: "Toca" },
    { code: '15816', name: "Togüí" },
    { code: '15820', name: "Tópaga" },
    { code: '15822', name: "Tota" },
    { code: '15832', name: "Tununguá" },
    { code: '15835', name: "Turmequé" },
    { code: '15837', name: "Tuta" },
    { code: '15839', name: "Tutazá" },
    { code: '15842', name: "Úmbita" },
    { code: '15861', name: "Ventaquemada" },
    { code: '15879', name: "Viracachá" },
    { code: '15897', name: "Zetaquira" },
    { code: '17001', name: "Manizales" },
    { code: '17013', name: "Aguadas" },
    { code: '17042', name: "Anserma" },
    { code: '17050', name: "Aranzazu" },
    { code: '17088', name: "Belalcázar" },
    { code: '17174', name: "Chinchiná" },
    { code: '17272', name: "Filadelfia" },
    { code: '17380', name: "La Dorada" },
    { code: '17388', name: "La Merced" },
    { code: '17433', name: "Manzanares" },
    { code: '17442', name: "Marmato" },
    { code: '17444', name: "Marquetalia" },
    { code: '17446', name: "Marulanda" },
    { code: '17486', name: "Neira" },
    { code: '17495', name: "Norcasia" },
    { code: '17513', name: "Pácora" },
    { code: '17524', name: "Palestina" },
    { code: '17541', name: "Pensilvania" },
    { code: '17614', name: "Riosucio" },
    { code: '17616', name: "Risaralda" },
    { code: '17653', name: "Salamina" },
    { code: '17662', name: "Samaná" },
    { code: '17665', name: "San José" },
    { code: '17777', name: "Supía" },
    { code: '17867', name: "Victoria" },
    { code: '17873', name: "Villamaría" },
    { code: '17877', name: "Viterbo" },
    { code: '18001', name: "Florencia" },
    { code: '18029', name: "Albania" },
    { code: '18094', name: "Belén de los Andaquíes" },
    { code: '18150', name: "Cartagena del Chairá" },
    { code: '18205', name: "Curillo" },
    { code: '18247', name: "El Doncello" },
    { code: '18256', name: "El Paujíl" },
    { code: '18410', name: "La Montañita" },
    { code: '18460', name: "Milán" },
    { code: '18479', name: "Morelia" },
    { code: '18592', name: "Puerto Rico" },
    { code: '18610', name: "San José del Fragua" },
    { code: '18753', name: "San Vicente del Caguán" },
    { code: '18756', name: "Solano" },
    { code: '18785', name: "Solita" },
    { code: '18860', name: "Valparaíso" },
    { code: '19001', name: "Popayán" },
    { code: '19022', name: "Almaguer" },
    { code: '19050', name: "Argelia" },
    { code: '19075', name: "Balboa" },
    { code: '19100', name: "Bolívar" },
    { code: '19110', name: "Buenos Aires" },
    { code: '19130', name: "Cajibío" },
    { code: '19137', name: "Caldono" },
    { code: '19142', name: "Caloto" },
    { code: '19212', name: "Corinto" },
    { code: '19256', name: "El Tambo" },
    { code: '19290', name: "Florencia" },
    { code: '19300', name: "Guachené" },
    { code: '19318', name: "Guapi" },
    { code: '19355', name: "Inzá" },
    { code: '19364', name: "Jambaló" },
    { code: '19392', name: "La Sierra" },
    { code: '19397', name: "La Vega" },
    { code: '19418', name: "López de Micay" },
    { code: '19450', name: "Mercaderes" },
    { code: '19455', name: "Miranda" },
    { code: '19473', name: "Morales" },
    { code: '19513', name: "Padilla" },
    { code: '19517', name: "Páez" },
    { code: '19532', name: "Patía" },
    { code: '19533', name: "Piamonte" },
    { code: '19548', name: "Piendamó - Tunía" },
    { code: '19573', name: "Puerto Tejada" },
    { code: '19585', name: "Puracé" },
    { code: '19622', name: "Rosas" },
    { code: '19693', name: "San Sebastián" },
    { code: '19698', name: "Santander de Quilichao" },
    { code: '19701', name: "Santa Rosa" },
    { code: '19743', name: "Silvia" },
    { code: '19760', name: "Sotará - Paispamba" },
    { code: '19780', name: "Suárez" },
    { code: '19785', name: "Sucre" },
    { code: '19807', name: "Timbío" },
    { code: '19809', name: "Timbiquí" },
    { code: '19821', name: "Toribío" },
    { code: '19824', name: "Totoró" },
    { code: '19845', name: "Villa Rica" },
    { code: '20001', name: "Valledupar" },
    { code: '20011', name: "Aguachica" },
    { code: '20013', name: "Agustín Codazzi" },
    { code: '20032', name: "Astrea" },
    { code: '20045', name: "Becerril" },
    { code: '20060', name: "Bosconia" },
    { code: '20175', name: "Chimichagua" },
    { code: '20178', name: "Chiriguaná" },
    { code: '20228', name: "Curumaní" },
    { code: '20238', name: "El Copey" },
    { code: '20250', name: "El Paso" },
    { code: '20295', name: "Gamarra" },
    { code: '20310', name: "González" },
    { code: '20383', name: "La Gloria" },
    { code: '20400', name: "La Jagua de Ibirico" },
    { code: '20443', name: "Manaure Balcón del Cesar" },
    { code: '20517', name: "Pailitas" },
    { code: '20550', name: "Pelaya" },
    { code: '20570', name: "Pueblo Bello" },
    { code: '20614', name: "Río de Oro" },
    { code: '20621', name: "La Paz" },
    { code: '20710', name: "San Alberto" },
    { code: '20750', name: "San Diego" },
    { code: '20770', name: "San Martín" },
    { code: '20787', name: "Tamalameque" },
    { code: '23001', name: "Montería" },
    { code: '23068', name: "Ayapel" },
    { code: '23079', name: "Buenavista" },
    { code: '23090', name: "Canalete" },
    { code: '23162', name: "Cereté" },
    { code: '23168', name: "Chimá" },
    { code: '23182', name: "Chinú" },
    { code: '23189', name: "Ciénaga de Oro" },
    { code: '23300', name: "Cotorra" },
    { code: '23350', name: "La Apartada" },
    { code: '23417', name: "Lorica" },
    { code: '23419', name: "Los Córdobas" },
    { code: '23464', name: "Momil" },
    { code: '23466', name: "Montelíbano" },
    { code: '23500', name: "Moñitos" },
    { code: '23555', name: "Planeta Rica" },
    { code: '23570', name: "Pueblo Nuevo" },
    { code: '23574', name: "Puerto Escondido" },
    { code: '23580', name: "Puerto Libertador" },
    { code: '23586', name: "Purísima de la Concepción" },
    { code: '23660', name: "Sahagún" },
    { code: '23670', name: "San Andrés de Sotavento" },
    { code: '23672', name: "San Antero" },
    { code: '23675', name: "San Bernardo del Viento" },
    { code: '23678', name: "San Carlos" },
    { code: '23682', name: "San José de Uré" },
    { code: '23686', name: "San Pelayo" },
    { code: '23807', name: "Tierralta" },
    { code: '23815', name: "Tuchín" },
    { code: '23855', name: "Valencia" },
    { code: '25001', name: "Agua de Dios" },
    { code: '25019', name: "Albán" },
    { code: '25035', name: "Anapoima" },
    { code: '25040', name: "Anolaima" },
    { code: '25053', name: "Arbeláez" },
    { code: '25086', name: "Beltrán" },
    { code: '25095', name: "Bituima" },
    { code: '25099', name: "Bojacá" },
    { code: '25120', name: "Cabrera" },
    { code: '25123', name: "Cachipay" },
    { code: '25126', name: "Cajicá" },
    { code: '25148', name: "Caparrapí" },
    { code: '25151', name: "Cáqueza" },
    { code: '25154', name: "Carmen de Carupa" },
    { code: '25168', name: "Chaguaní" },
    { code: '25175', name: "Chía" },
    { code: '25178', name: "Chipaque" },
    { code: '25181', name: "Choachí" },
    { code: '25183', name: "Chocontá" },
    { code: '25200', name: "Cogua" },
    { code: '25214', name: "Cota" },
    { code: '25224', name: "Cucunubá" },
    { code: '25245', name: "El Colegio" },
    { code: '25258', name: "El Peñón" },
    { code: '25260', name: "El Rosal" },
    { code: '25269', name: "Facatativá" },
    { code: '25279', name: "Fómeque" },
    { code: '25281', name: "Fosca" },
    { code: '25286', name: "Funza" },
    { code: '25288', name: "Fúquene" },
    { code: '25290', name: "Fusagasugá" },
    { code: '25293', name: "Gachalá" },
    { code: '25295', name: "Gachancipá" },
    { code: '25297', name: "Gachetá" },
    { code: '25299', name: "Gama" },
    { code: '25307', name: "Girardot" },
    { code: '25312', name: "Granada" },
    { code: '25317', name: "Guachetá" },
    { code: '25320', name: "Guaduas" },
    { code: '25322', name: "Guasca" },
    { code: '25324', name: "Guataquí" },
    { code: '25326', name: "Guatavita" },
    { code: '25328', name: "Guayabal de Síquima" },
    { code: '25335', name: "Guayabetal" },
    { code: '25339', name: "Gutiérrez" },
    { code: '25368', name: "Jerusalén" },
    { code: '25372', name: "Junín" },
    { code: '25377', name: "La Calera" },
    { code: '25386', name: "La Mesa" },
    { code: '25394', name: "La Palma" },
    { code: '25398', name: "La Peña" },
    { code: '25402', name: "La Vega" },
    { code: '25407', name: "Lenguazaque" },
    { code: '25426', name: "Machetá" },
    { code: '25430', name: "Madrid" },
    { code: '25436', name: "Manta" },
    { code: '25438', name: "Medina" },
    { code: '25473', name: "Mosquera" },
    { code: '25483', name: "Nariño" },
    { code: '25486', name: "Nemocón" },
    { code: '25488', name: "Nilo" },
    { code: '25489', name: "Nimaima" },
    { code: '25491', name: "Nocaima" },
    { code: '25506', name: "Venecia" },
    { code: '25513', name: "Pacho" },
    { code: '25518', name: "Paime" },
    { code: '25524', name: "Pandi" },
    { code: '25530', name: "Paratebueno" },
    { code: '25535', name: "Pasca" },
    { code: '25572', name: "Puerto Salgar" },
    { code: '25580', name: "Pulí" },
    { code: '25592', name: "Quebradanegra" },
    { code: '25594', name: "Quetame" },
    { code: '25596', name: "Quipile" },
    { code: '25599', name: "Apulo" },
    { code: '25612', name: "Ricaurte" },
    { code: '25645', name: "San Antonio del Tequendama" },
    { code: '25649', name: "San Bernardo" },
    { code: '25653', name: "San Cayetano" },
    { code: '25658', name: "San Francisco" },
    { code: '25662', name: "San Juan de Rioseco" },
    { code: '25718', name: "Sasaima" },
    { code: '25736', name: "Sesquilé" },
    { code: '25740', name: "Sibaté" },
    { code: '25743', name: "Silvania" },
    { code: '25745', name: "Simijaca" },
    { code: '25754', name: "Soacha" },
    { code: '25758', name: "Sopó" },
    { code: '25769', name: "Subachoque" },
    { code: '25772', name: "Suesca" },
    { code: '25777', name: "Supatá" },
    { code: '25779', name: "Susa" },
    { code: '25781', name: "Sutatausa" },
    { code: '25785', name: "Tabio" },
    { code: '25793', name: "Tausa" },
    { code: '25797', name: "Tena" },
    { code: '25799', name: "Tenjo" },
    { code: '25805', name: "Tibacuy" },
    { code: '25807', name: "Tibirita" },
    { code: '25815', name: "Tocaima" },
    { code: '25817', name: "Tocancipá" },
    { code: '25823', name: "Topaipí" },
    { code: '25839', name: "Ubalá" },
    { code: '25841', name: "Ubaque" },
    { code: '25843', name: "Villa de San Diego de Ubaté" },
    { code: '25845', name: "Une" },
    { code: '25851', name: "Útica" },
    { code: '25862', name: "Vergara" },
    { code: '25867', name: "Vianí" },
    { code: '25871', name: "Villagómez" },
    { code: '25873', name: "Villapinzón" },
    { code: '25875', name: "Villeta" },
    { code: '25878', name: "Viotá" },
    { code: '25885', name: "Yacopí" },
    { code: '25898', name: "Zipacón" },
    { code: '25899', name: "Zipaquirá" },
    { code: '27001', name: "Quibdó" },
    { code: '27006', name: "Acandí" },
    { code: '27025', name: "Alto Baudó" },
    { code: '27050', name: "Atrato" },
    { code: '27073', name: "Bagadó" },
    { code: '27075', name: "Bahía Solano" },
    { code: '27077', name: "Bajo Baudó" },
    { code: '27099', name: "Bojayá" },
    { code: '27135', name: "El Cantón del San Pablo" },
    { code: '27150', name: "Carmen del Darién" },
    { code: '27160', name: "Cértegui" },
    { code: '27205', name: "Condoto" },
    { code: '27245', name: "El Carmen de Atrato" },
    { code: '27250', name: "El Litoral del San Juan" },
    { code: '27361', name: "Istmina" },
    { code: '27372', name: "Juradó" },
    { code: '27413', name: "Lloró" },
    { code: '27425', name: "Medio Atrato" },
    { code: '27430', name: "Medio Baudó" },
    { code: '27450', name: "Medio San Juan" },
    { code: '27491', name: "Nóvita" },
    { code: '27493', name: "Nuevo Belén de Bajirá" },
    { code: '27495', name: "Nuquí" },
    { code: '27580', name: "Río Iró" },
    { code: '27600', name: "Río Quito" },
    { code: '27615', name: "Riosucio" },
    { code: '27660', name: "San José del Palmar" },
    { code: '27745', name: "Sipí" },
    { code: '27787', name: "Tadó" },
    { code: '27800', name: "Unguía" },
    { code: '27810', name: "Unión Panamericana" },
    { code: '41001', name: "Neiva" },
    { code: '41006', name: "Acevedo" },
    { code: '41013', name: "Agrado" },
    { code: '41016', name: "Aipe" },
    { code: '41020', name: "Algeciras" },
    { code: '41026', name: "Altamira" },
    { code: '41078', name: "Baraya" },
    { code: '41132', name: "Campoalegre" },
    { code: '41206', name: "Colombia" },
    { code: '41244', name: "Elías" },
    { code: '41298', name: "Garzón" },
    { code: '41306', name: "Gigante" },
    { code: '41319', name: "Guadalupe" },
    { code: '41349', name: "Hobo" },
    { code: '41357', name: "Íquira" },
    { code: '41359', name: "Isnos" },
    { code: '41378', name: "La Argentina" },
    { code: '41396', name: "La Plata" },
    { code: '41483', name: "Nátaga" },
    { code: '41503', name: "Oporapa" },
    { code: '41518', name: "Paicol" },
    { code: '41524', name: "Palermo" },
    { code: '41530', name: "Palestina" },
    { code: '41548', name: "Pital" },
    { code: '41551', name: "Pitalito" },
    { code: '41615', name: "Rivera" },
    { code: '41660', name: "Saladoblanco" },
    { code: '41668', name: "San Agustín" },
    { code: '41676', name: "Santa María" },
    { code: '41770', name: "Suaza" },
    { code: '41791', name: "Tarqui" },
    { code: '41797', name: "Tesalia" },
    { code: '41799', name: "Tello" },
    { code: '41801', name: "Teruel" },
    { code: '41807', name: "Timaná" },
    { code: '41872', name: "Villavieja" },
    { code: '41885', name: "Yaguará" },
    { code: '44001', name: "Riohacha" },
    { code: '44035', name: "Albania" },
    { code: '44078', name: "Barrancas" },
    { code: '44090', name: "Dibulla" },
    { code: '44098', name: "Distracción" },
    { code: '44110', name: "El Molino" },
    { code: '44279', name: "Fonseca" },
    { code: '44378', name: "Hatonuevo" },
    { code: '44420', name: "La Jagua del Pilar" },
    { code: '44430', name: "Maicao" },
    { code: '44560', name: "Manaure" },
    { code: '44650', name: "San Juan del Cesar" },
    { code: '44847', name: "Uribia" },
    { code: '44855', name: "Urumita" },
    { code: '44874', name: "Villanueva" },
    { code: '47001', name: "Santa Marta" },
    { code: '47030', name: "Algarrobo" },
    { code: '47053', name: "Aracataca" },
    { code: '47058', name: "Ariguaní" },
    { code: '47161', name: "Cerro de San Antonio" },
    { code: '47170', name: "Chivolo" },
    { code: '47189', name: "Ciénaga" },
    { code: '47205', name: "Concordia" },
    { code: '47245', name: "El Banco" },
    { code: '47258', name: "El Piñón" },
    { code: '47268', name: "El Retén" },
    { code: '47288', name: "Fundación" },
    { code: '47318', name: "Guamal" },
    { code: '47460', name: "Nueva Granada" },
    { code: '47541', name: "Pedraza" },
    { code: '47545', name: "Pijiño del Carmen" },
    { code: '47551', name: "Pivijay" },
    { code: '47555', name: "Plato" },
    { code: '47570', name: "Puebloviejo" },
    { code: '47605', name: "Remolino" },
    { code: '47660', name: "Sabanas de San Ángel" },
    { code: '47675', name: "Salamina" },
    { code: '47692', name: "San Sebastián de Buenavista" },
    { code: '47703', name: "San Zenón" },
    { code: '47707', name: "Santa Ana" },
    { code: '47720', name: "Santa Bárbara de Pinto" },
    { code: '47745', name: "Sitionuevo" },
    { code: '47798', name: "Tenerife" },
    { code: '47960', name: "Zapayán" },
    { code: '47980', name: "Zona Bananera" },
    { code: '50001', name: "Villavicencio" },
    { code: '50006', name: "Acacías" },
    { code: '50110', name: "Barranca de Upía" },
    { code: '50124', name: "Cabuyaro" },
    { code: '50150', name: "Castilla la Nueva" },
    { code: '50223', name: "Cubarral" },
    { code: '50226', name: "Cumaral" },
    { code: '50245', name: "El Calvario" },
    { code: '50251', name: "El Castillo" },
    { code: '50270', name: "El Dorado" },
    { code: '50287', name: "Fuente de Oro" },
    { code: '50313', name: "Granada" },
    { code: '50318', name: "Guamal" },
    { code: '50325', name: "Mapiripán" },
    { code: '50330', name: "Mesetas" },
    { code: '50350', name: "La Macarena" },
    { code: '50370', name: "Uribe" },
    { code: '50400', name: "Lejanías" },
    { code: '50450', name: "Puerto Concordia" },
    { code: '50568', name: "Puerto Gaitán" },
    { code: '50573', name: "Puerto López" },
    { code: '50577', name: "Puerto Lleras" },
    { code: '50590', name: "Puerto Rico" },
    { code: '50606', name: "Restrepo" },
    { code: '50680', name: "San Carlos de Guaroa" },
    { code: '50683', name: "San Juan de Arama" },
    { code: '50686', name: "San Juanito" },
    { code: '50689', name: "San Martín" },
    { code: '50711', name: "Vistahermosa" },
    { code: '52001', name: "Pasto" },
    { code: '52019', name: "Albán" },
    { code: '52022', name: "Aldana" },
    { code: '52036', name: "Ancuya" },
    { code: '52051', name: "Arboleda" },
    { code: '52079', name: "Barbacoas" },
    { code: '52083', name: "Belén" },
    { code: '52110', name: "Buesaco" },
    { code: '52203', name: "Colón" },
    { code: '52207', name: "Consacá" },
    { code: '52210', name: "Contadero" },
    { code: '52215', name: "Córdoba" },
    { code: '52224', name: "Cuaspud Carlosama" },
    { code: '52227', name: "Cumbal" },
    { code: '52233', name: "Cumbitara" },
    { code: '52240', name: "Chachagüí" },
    { code: '52250', name: "El Charco" },
    { code: '52254', name: "El Peñol" },
    { code: '52256', name: "El Rosario" },
    { code: '52258', name: "El Tablón de Gómez" },
    { code: '52260', name: "El Tambo" },
    { code: '52287', name: "Funes" },
    { code: '52317', name: "Guachucal" },
    { code: '52320', name: "Guaitarilla" },
    { code: '52323', name: "Gualmatán" },
    { code: '52352', name: "Iles" },
    { code: '52354', name: "Imués" },
    { code: '52356', name: "Ipiales" },
    { code: '52378', name: "La Cruz" },
    { code: '52381', name: "La Florida" },
    { code: '52385', name: "La Llanada" },
    { code: '52390', name: "La Tola" },
    { code: '52399', name: "La Unión" },
    { code: '52405', name: "Leiva" },
    { code: '52411', name: "Linares" },
    { code: '52418', name: "Los Andes" },
    { code: '52427', name: "Magüí" },
    { code: '52435', name: "Mallama" },
    { code: '52473', name: "Mosquera" },
    { code: '52480', name: "Nariño" },
    { code: '52490', name: "Olaya Herrera" },
    { code: '52506', name: "Ospina" },
    { code: '52520', name: "Francisco Pizarro" },
    { code: '52540', name: "Policarpa" },
    { code: '52560', name: "Potosí" },
    { code: '52565', name: "Providencia" },
    { code: '52573', name: "Puerres" },
    { code: '52585', name: "Pupiales" },
    { code: '52612', name: "Ricaurte" },
    { code: '52621', name: "Roberto Payán" },
    { code: '52678', name: "Samaniego" },
    { code: '52683', name: "Sandoná" },
    { code: '52685', name: "San Bernardo" },
    { code: '52687', name: "San Lorenzo" },
    { code: '52693', name: "San Pablo" },
    { code: '52694', name: "San Pedro de Cartago" },
    { code: '52696', name: "Santa Bárbara" },
    { code: '52699', name: "Santacruz" },
    { code: '52720', name: "Sapuyes" },
    { code: '52786', name: "Taminango" },
    { code: '52788', name: "Tangua" },
    { code: '52835', name: "San Andrés de Tumaco" },
    { code: '52838', name: "Túquerres" },
    { code: '52885', name: "Yacuanquer" },
    { code: '54001', name: "San José de Cúcuta" },
    { code: '54003', name: "Ábrego" },
    { code: '54051', name: "Arboledas" },
    { code: '54099', name: "Bochalema" },
    { code: '54109', name: "Bucarasica" },
    { code: '54125', name: "Cácota" },
    { code: '54128', name: "Cáchira" },
    { code: '54172', name: "Chinácota" },
    { code: '54174', name: "Chitagá" },
    { code: '54206', name: "Convención" },
    { code: '54223', name: "Cucutilla" },
    { code: '54239', name: "Durania" },
    { code: '54245', name: "El Carmen" },
    { code: '54250', name: "El Tarra" },
    { code: '54261', name: "El Zulia" },
    { code: '54313', name: "Gramalote" },
    { code: '54344', name: "Hacarí" },
    { code: '54347', name: "Herrán" },
    { code: '54377', name: "Labateca" },
    { code: '54385', name: "La Esperanza" },
    { code: '54398', name: "La Playa" },
    { code: '54405', name: "Los Patios" },
    { code: '54418', name: "Lourdes" },
    { code: '54480', name: "Mutiscua" },
    { code: '54498', name: "Ocaña" },
    { code: '54518', name: "Pamplona" },
    { code: '54520', name: "Pamplonita" },
    { code: '54553', name: "Puerto Santander" },
    { code: '54599', name: "Ragonvalia" },
    { code: '54660', name: "Salazar" },
    { code: '54670', name: "San Calixto" },
    { code: '54673', name: "San Cayetano" },
    { code: '54680', name: "Santiago" },
    { code: '54720', name: "Sardinata" },
    { code: '54743', name: "Silos" },
    { code: '54800', name: "Teorama" },
    { code: '54810', name: "Tibú" },
    { code: '54820', name: "Toledo" },
    { code: '54871', name: "Villa Caro" },
    { code: '54874', name: "Villa del Rosario" },
    { code: '63001', name: "Armenia" },
    { code: '63111', name: "Buenavista" },
    { code: '63130', name: "Calarcá" },
    { code: '63190', name: "Circasia" },
    { code: '63212', name: "Córdoba" },
    { code: '63272', name: "Filandia" },
    { code: '63302', name: "Génova" },
    { code: '63401', name: "La Tebaida" },
    { code: '63470', name: "Montenegro" },
    { code: '63548', name: "Pijao" },
    { code: '63594', name: "Quimbaya" },
    { code: '63690', name: "Salento" },
    { code: '66001', name: "Pereira" },
    { code: '66045', name: "Apía" },
    { code: '66075', name: "Balboa" },
    { code: '66088', name: "Belén de Umbría" },
    { code: '66170', name: "Dosquebradas" },
    { code: '66318', name: "Guática" },
    { code: '66383', name: "La Celia" },
    { code: '66400', name: "La Virginia" },
    { code: '66440', name: "Marsella" },
    { code: '66456', name: "Mistrató" },
    { code: '66572', name: "Pueblo Rico" },
    { code: '66594', name: "Quinchía" },
    { code: '66682', name: "Santa Rosa de Cabal" },
    { code: '66687', name: "Santuario" },
    { code: '68001', name: "Bucaramanga" },
    { code: '68013', name: "Aguada" },
    { code: '68020', name: "Albania" },
    { code: '68051', name: "Aratoca" },
    { code: '68077', name: "Barbosa" },
    { code: '68079', name: "Barichara" },
    { code: '68081', name: "Barrancabermeja" },
    { code: '68092', name: "Betulia" },
    { code: '68101', name: "Bolívar" },
    { code: '68121', name: "Cabrera" },
    { code: '68132', name: "California" },
    { code: '68147', name: "Capitanejo" },
    { code: '68152', name: "Carcasí" },
    { code: '68160', name: "Cepitá" },
    { code: '68162', name: "Cerrito" },
    { code: '68167', name: "Charalá" },
    { code: '68169', name: "Charta" },
    { code: '68176', name: "Chima" },
    { code: '68179', name: "Chipatá" },
    { code: '68190', name: "Cimitarra" },
    { code: '68207', name: "Concepción" },
    { code: '68209', name: "Confines" },
    { code: '68211', name: "Contratación" },
    { code: '68217', name: "Coromoro" },
    { code: '68229', name: "Curití" },
    { code: '68235', name: "El Carmen de Chucurí" },
    { code: '68245', name: "El Guacamayo" },
    { code: '68250', name: "El Peñón" },
    { code: '68255', name: "El Playón" },
    { code: '68264', name: "Encino" },
    { code: '68266', name: "Enciso" },
    { code: '68271', name: "Florián" },
    { code: '68276', name: "Floridablanca" },
    { code: '68296', name: "Galán" },
    { code: '68298', name: "Gámbita" },
    { code: '68307', name: "Girón" },
    { code: '68318', name: "Guaca" },
    { code: '68320', name: "Guadalupe" },
    { code: '68322', name: "Guapotá" },
    { code: '68324', name: "Guavatá" },
    { code: '68327', name: "Güepsa" },
    { code: '68344', name: "Hato" },
    { code: '68368', name: "Jesús María" },
    { code: '68370', name: "Jordán" },
    { code: '68377', name: "La Belleza" },
    { code: '68385', name: "Landázuri" },
    { code: '68397', name: "La Paz" },
    { code: '68406', name: "Lebrija" },
    { code: '68418', name: "Los Santos" },
    { code: '68425', name: "Macaravita" },
    { code: '68432', name: "Málaga" },
    { code: '68444', name: "Matanza" },
    { code: '68464', name: "Mogotes" },
    { code: '68468', name: "Molagavita" },
    { code: '68498', name: "Ocamonte" },
    { code: '68500', name: "Oiba" },
    { code: '68502', name: "Onzaga" },
    { code: '68522', name: "Palmar" },
    { code: '68524', name: "Palmas del Socorro" },
    { code: '68533', name: "Páramo" },
    { code: '68547', name: "Piedecuesta" },
    { code: '68549', name: "Pinchote" },
    { code: '68572', name: "Puente Nacional" },
    { code: '68573', name: "Puerto Parra" },
    { code: '68575', name: "Puerto Wilches" },
    { code: '68615', name: "Rionegro" },
    { code: '68655', name: "Sabana de Torres" },
    { code: '68669', name: "San Andrés" },
    { code: '68673', name: "San Benito" },
    { code: '68679', name: "San Gil" },
    { code: '68682', name: "San Joaquín" },
    { code: '68684', name: "San José de Miranda" },
    { code: '68686', name: "San Miguel" },
    { code: '68689', name: "San Vicente de Chucurí" },
    { code: '68705', name: "Santa Bárbara" },
    { code: '68720', name: "Santa Helena del Opón" },
    { code: '68745', name: "Simacota" },
    { code: '68755', name: "Socorro" },
    { code: '68770', name: "Suaita" },
    { code: '68773', name: "Sucre" },
    { code: '68780', name: "Suratá" },
    { code: '68820', name: "Tona" },
    { code: '68855', name: "Valle de San José" },
    { code: '68861', name: "Vélez" },
    { code: '68867', name: "Vetas" },
    { code: '68872', name: "Villanueva" },
    { code: '68895', name: "Zapatoca" },
    { code: '70001', name: "Sincelejo" },
    { code: '70110', name: "Buenavista" },
    { code: '70124', name: "Caimito" },
    { code: '70204', name: "Colosó" },
    { code: '70215', name: "Corozal" },
    { code: '70221', name: "Coveñas" },
    { code: '70230', name: "Chalán" },
    { code: '70233', name: "El Roble" },
    { code: '70235', name: "Galeras" },
    { code: '70265', name: "Guaranda" },
    { code: '70400', name: "La Unión" },
    { code: '70418', name: "Los Palmitos" },
    { code: '70429', name: "Majagual" },
    { code: '70473', name: "Morroa" },
    { code: '70508', name: "Ovejas" },
    { code: '70523', name: "Palmito" },
    { code: '70670', name: "Sampués" },
    { code: '70678', name: "San Benito Abad" },
    { code: '70702', name: "San Juan de Betulia" },
    { code: '70708', name: "San Marcos" },
    { code: '70713', name: "San Onofre" },
    { code: '70717', name: "San Pedro" },
    { code: '70742', name: "San Luis de Sincé" },
    { code: '70771', name: "Sucre" },
    { code: '70820', name: "Santiago de Tolú" },
    { code: '70823', name: "San José de Toluviejo" },
    { code: '73001', name: "Ibagué" },
    { code: '73024', name: "Alpujarra" },
    { code: '73026', name: "Alvarado" },
    { code: '73030', name: "Ambalema" },
    { code: '73043', name: "Anzoátegui" },
    { code: '73055', name: "Armero" },
    { code: '73067', name: "Ataco" },
    { code: '73124', name: "Cajamarca" },
    { code: '73148', name: "Carmen de Apicalá" },
    { code: '73152', name: "Casabianca" },
    { code: '73168', name: "Chaparral" },
    { code: '73200', name: "Coello" },
    { code: '73217', name: "Coyaima" },
    { code: '73226', name: "Cunday" },
    { code: '73236', name: "Dolores" },
    { code: '73268', name: "Espinal" },
    { code: '73270', name: "Falan" },
    { code: '73275', name: "Flandes" },
    { code: '73283', name: "Fresno" },
    { code: '73319', name: "Guamo" },
    { code: '73347', name: "Herveo" },
    { code: '73349', name: "Honda" },
    { code: '73352', name: "Icononzo" },
    { code: '73408', name: "Lérida" },
    { code: '73411', name: "Líbano" },
    { code: '73443', name: "San Sebastián de Mariquita" },
    { code: '73449', name: "Melgar" },
    { code: '73461', name: "Murillo" },
    { code: '73483', name: "Natagaima" },
    { code: '73504', name: "Ortega" },
    { code: '73520', name: "Palocabildo" },
    { code: '73547', name: "Piedras" },
    { code: '73555', name: "Planadas" },
    { code: '73563', name: "Prado" },
    { code: '73585', name: "Purificación" },
    { code: '73616', name: "Rioblanco" },
    { code: '73622', name: "Roncesvalles" },
    { code: '73624', name: "Rovira" },
    { code: '73671', name: "Saldaña" },
    { code: '73675', name: "San Antonio" },
    { code: '73678', name: "San Luis" },
    { code: '73686', name: "Santa Isabel" },
    { code: '73770', name: "Suárez" },
    { code: '73854', name: "Valle de San Juan" },
    { code: '73861', name: "Venadillo" },
    { code: '73870', name: "Villahermosa" },
    { code: '73873', name: "Villarrica" },
    { code: '76001', name: "Santiago de Cali" },
    { code: '76020', name: "Alcalá" },
    { code: '76036', name: "Andalucía" },
    { code: '76041', name: "Ansermanuevo" },
    { code: '76054', name: "Argelia" },
    { code: '76100', name: "Bolívar" },
    { code: '76109', name: "Buenaventura" },
    { code: '76111', name: "Guadalajara de Buga" },
    { code: '76113', name: "Bugalagrande" },
    { code: '76122', name: "Caicedonia" },
    { code: '76126', name: "Calima" },
    { code: '76130', name: "Candelaria" },
    { code: '76147', name: "Cartago" },
    { code: '76233', name: "Dagua" },
    { code: '76243', name: "El Águila" },
    { code: '76246', name: "El Cairo" },
    { code: '76248', name: "El Cerrito" },
    { code: '76250', name: "El Dovio" },
    { code: '76275', name: "Florida" },
    { code: '76306', name: "Ginebra" },
    { code: '76318', name: "Guacarí" },
    { code: '76364', name: "Jamundí" },
    { code: '76377', name: "La Cumbre" },
    { code: '76400', name: "La Unión" },
    { code: '76403', name: "La Victoria" },
    { code: '76497', name: "Obando" },
    { code: '76520', name: "Palmira" },
    { code: '76563', name: "Pradera" },
    { code: '76606', name: "Restrepo" },
    { code: '76616', name: "Riofrío" },
    { code: '76622', name: "Roldanillo" },
    { code: '76670', name: "San Pedro" },
    { code: '76736', name: "Sevilla" },
    { code: '76823', name: "Toro" },
    { code: '76828', name: "Trujillo" },
    { code: '76834', name: "Tuluá" },
    { code: '76845', name: "Ulloa" },
    { code: '76863', name: "Versalles" },
    { code: '76869', name: "Vijes" },
    { code: '76890', name: "Yotoco" },
    { code: '76892', name: "Yumbo" },
    { code: '76895', name: "Zarzal" },
    { code: '81001', name: "Arauca" },
    { code: '81065', name: "Arauquita" },
    { code: '81220', name: "Cravo Norte" },
    { code: '81300', name: "Fortul" },
    { code: '81591', name: "Puerto Rondón" },
    { code: '81736', name: "Saravena" },
    { code: '81794', name: "Tame" },
    { code: '85001', name: "Yopal" },
    { code: '85010', name: "Aguazul" },
    { code: '85015', name: "Chámeza" },
    { code: '85125', name: "Hato Corozal" },
    { code: '85136', name: "La Salina" },
    { code: '85139', name: "Maní" },
    { code: '85162', name: "Monterrey" },
    { code: '85225', name: "Nunchía" },
    { code: '85230', name: "Orocué" },
    { code: '85250', name: "Paz de Ariporo" },
    { code: '85263', name: "Pore" },
    { code: '85279', name: "Recetor" },
    { code: '85300', name: "Sabanalarga" },
    { code: '85315', name: "Sácama" },
    { code: '85325', name: "San Luis de Palenque" },
    { code: '85400', name: "Támara" },
    { code: '85410', name: "Tauramena" },
    { code: '85430', name: "Trinidad" },
    { code: '85440', name: "Villanueva" },
    { code: '86001', name: "Mocoa" },
    { code: '86219', name: "Colón" },
    { code: '86320', name: "Orito" },
    { code: '86568', name: "Puerto Asís" },
    { code: '86569', name: "Puerto Caicedo" },
    { code: '86571', name: "Puerto Guzmán" },
    { code: '86573', name: "Puerto Leguízamo" },
    { code: '86749', name: "Sibundoy" },
    { code: '86755', name: "San Francisco" },
    { code: '86757', name: "San Miguel" },
    { code: '86760', name: "Santiago" },
    { code: '86865', name: "Valle del Guamuez" },
    { code: '86885', name: "Villagarzón" },
    { code: '88001', name: "San Andrés" },
    { code: '88564', name: "Providencia" },
    { code: '91001', name: "Leticia" },
    { code: '91263', name: "El Encanto" },
    { code: '91405', name: "La Chorrera" },
    { code: '91407', name: "La Pedrera" },
    { code: '91430', name: "La Victoria" },
    { code: '91460', name: "Mirití - Paraná" },
    { code: '91530', name: "Puerto Alegría" },
    { code: '91536', name: "Puerto Arica" },
    { code: '91540', name: "Puerto Nariño" },
    { code: '91669', name: "Puerto Santander" },
    { code: '91798', name: "Tarapacá" },
    { code: '94001', name: "Inírida" },
    { code: '94343', name: "Barrancominas" },
    { code: '94883', name: "San Felipe" },
    { code: '94884', name: "Puerto Colombia" },
    { code: '94885', name: "La Guadalupe" },
    { code: '94886', name: "Cacahual" },
    { code: '94887', name: "Pana Pana" },
    { code: '94888', name: "Morichal" },
    { code: '95001', name: "San José del Guaviare" },
    { code: '95015', name: "Calamar" },
    { code: '95025', name: "El Retorno" },
    { code: '95200', name: "Miraflores" },
    { code: '97001', name: "Mitú" },
    { code: '97161', name: "Carurú" },
    { code: '97511', name: "Pacoa" },
    { code: '97666', name: "Taraira" },
    { code: '97777', name: "Papunahua" },
    { code: '97889', name: "Yavaraté" },
    { code: '99001', name: "Puerto Carreño" },
    { code: '99524', name: "La Primavera" },
    { code: '99624', name: "Santa Rosalía" },
    { code: '99773', name: "Cumaribo" },
];
//# sourceMappingURL=divipola-data.js.map